import React from 'react';
import heroImage from '../../../assets/images/theraputic_screen/hero_image.jpg';

const HeroSection = () => {
  const services = [
    { id: 'physical-therapy', name: 'Physical Therapy' },
    { id: 'speech-therapy', name: 'Speech Therapy' },
    { id: 'occupational-therapy', name: 'Occupational Therapy' },
  ];

  const scrollToSpecificSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className="w-full h-[350px] md:h-[550px] 2xl:h-[600px] 4xl:h-[750px] 5xl:h-[850px] 3xl:h-[700px] bg-cover bg-center relative z-20"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="absolute top-0 left-0 w-full bg-headerBg/90 px-4 py-2 xs:py-4 xs:pb-4 sm:pb-1">
        <div className="flex items-start md:items-center flex-col md:flex-row md:gap-10 justify-normal md:justify-between  max-w-[1200px] mx-auto">
          <p className="text-white text-[20px] md:text-[28px] lg:text-[38px] 2xl:text-[40px] 3xl:text-[53px] font-[700] tracking-wide">
            Therapeutic Services
          </p>
          <div className="flex items-center gap-6 md:gap-10 md:pl-8 xs:pl-0">
            {services.map((service) => (
              <p
                key={service.id}
                className="text-sm sm:text-lg md:text-lg 2xl:text-xl text-white mt-3 cursor-pointer"
                onClick={() => scrollToSpecificSection(service.id)}
              >
                {service.name}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
